import React, { ReactNode } from 'react';
import Container from '@v2/shared/components/Container';

/**
 * The box the page sits in, and where `main` lives. MagSpot's counterpart; see the note
 * there about `flex-1` standing in for the legacy `#wrapper` min-height.
 */
export default function Content({ children }: { children: ReactNode }) {
  return (
    <Container className="flex-1">
      <main id="main" role="main" className="py-5">
        {children}
      </main>
    </Container>
  );
}
